import {
  SIGNUP_USER,
  CHECK_CHANGED,
  EMAIL_CHANGED,
  PASSWORD_CHANGED,
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAIL,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_FAIL,
  USER_AUTHED,
  USER_NOT_AUTHED
} from '../../_actions/types';

const defaultState = {
  email: '',
  password: '',
  error: '',
  loading: false,
  user: false,
  checked: false

};

export default function (state = defaultState, action ) {
    switch (action.type) {
      case CHECK_CHANGED:
        return { ...state, checked: action.payload};
      case EMAIL_CHANGED:
        return { ...state, email: action.payload };
      case PASSWORD_CHANGED:
        return { ...state, password: action.payload };
      case LOGIN_USER:
        return { ...state, loading: true, error: ''}
      case SIGNUP_USER:
        return { ...state, loading: true, error: ''}
      case LOGIN_USER_SUCCESS:
        return { ...state, user: action.payload, error: '', loading: false };
      case LOGIN_USER_FAIL:
        return { ...state, error: 'Authentication Failed.', password: '', loading: false }
      case USER_AUTHED:
        return { ...state, user: action.user, realtor: action.realtor }
      case USER_NOT_AUTHED:
        return { ...state}
      case LOGOUT_USER_SUCCESS:
        return { ...state, user: false }
      case LOGOUT_USER_FAIL:
        return { ...state }
      default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/components/auth/auth_reducer.js